export default __webpack_public_path__ + "static/media/fam5.198b720a.png";